import { FormGroup, FormArray, FormArrayName } from '@angular/forms';

import { ValidationMessages, ValidationRules } from '../models/validationMessage';

// Generic validator for Reactive forms
// Implemented as a class, not a service, so it can retain state for multiple forms.
export class GenericFormValidator {

  // Provide the set of valid validation messages
  // Stucture:
  // controlName1: {
  //     validationRuleName1: 'Validation Message.',
  //     validationRuleName2: 'Validation Message.'
  // },
  // controlName2: {
  //     validationRuleName1: 'Validation Message.',
  //     validationRuleName2: 'Validation Message.'
  // }

  constructor(private validationRules: ValidationRules) {
    //console.log('GenericFormValidator');
  }

  // Processes each control within a FormGroup
  // And returns a set of validation messages to display
  // Structure
  // controlName1: 'Validation Message.',
  // controlName2: 'Validation Message.'
  processMessages(container: FormGroup, formArray: string = ""): ValidationMessages {

    let messages = new ValidationMessages();
    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        let c = container.controls[controlKey];
        // If it is a FormGroup, process its child controls.
        if (c instanceof FormGroup) {
          //console.log('Found form form group: ' + controlKey, c);                    
          //console.log('messages', messages);
          let childMessages = this.processMessages(c);

          //console.log('child messages', childMessages);                    
          Object.assign(messages.Messages, childMessages.Messages);
        } else if (c instanceof FormArray) {

          for (var i in c.controls) {
            let fg = c.controls[i];

            if (fg instanceof FormGroup) {
              let arrayMessages = this.processMessages(fg, controlKey);

              var msg = { [i]: arrayMessages.Messages };

              if (messages.FormArrays[controlKey] == undefined) {
                messages.FormArrays[controlKey] = msg;
              } else {
                Object.assign(messages.FormArrays[controlKey], msg);
              }

            }
          }
        } else {
          // Only validate if there are validation messages for the control

          if (formArray != "") {

            if (this.validationRules.FormArrays[formArray] != null && this.validationRules.FormArrays[formArray][controlKey] != null) {

              messages.Messages[controlKey] = '';
              if ((c.dirty || c.touched) && c.errors) {
                Object.keys(c.errors).map(messageKey => {

                  if (this.validationRules.FormArrays[formArray][controlKey][messageKey]) {
                    messages.Messages[controlKey] += this.validationRules.FormArrays[formArray][controlKey][messageKey] + ' ';
                  }
                });
              }
            }

          }
          else if (this.validationRules.Messages[controlKey]) {

            messages.Messages[controlKey] = '';
            if ((c.dirty || c.touched) && c.errors) {
              Object.keys(c.errors).map(messageKey => {

                if (this.validationRules.Messages[controlKey][messageKey]) {
                  messages.Messages[controlKey] += this.validationRules.Messages[controlKey][messageKey] + ' ';
                }
              });
            }

          }
        }
      }
    }

    return messages;
  }

  resetAll(container: FormGroup, formArray: string = ""): void {
    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        let c = container.controls[controlKey];

        if (c instanceof FormGroup) {
          this.resetAll(c);
        } else if (c instanceof FormArray) {
          for (var i in c.controls) {
            let fg = c.controls[i];

            if (fg instanceof FormGroup) {
              this.resetAll(fg);
            }
          }
        } else {
          c.markAsPristine();
          c.markAsUntouched();
          c.updateValueAndValidity();
        }
      }
    }
  }

  touchAll(container: FormGroup, formArray: string = ""): void {
    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        let c = container.controls[controlKey];

        if (c instanceof FormGroup) {
          this.touchAll(c);
        } else if (c instanceof FormArray) {
          for (var i in c.controls) {
            let fg = c.controls[i];

            if (fg instanceof FormGroup) {
              this.touchAll(fg);
            }
          }
        } else {
          c.markAsTouched();
          c.updateValueAndValidity();
        }
      }
    }
  }

  firstError(container: FormGroup, formArray: string = "", node: string = ""): string {

    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        let c = container.controls[controlKey];

        if (c instanceof FormGroup) {

          let firstGroupControl = this.firstError(c, formArray, node);

          if (firstGroupControl) {
            return firstGroupControl;
          }

        } else if (c instanceof FormArray) {

          for (var i in c.controls) {
            let fg = c.controls[i];

            if (fg instanceof FormGroup) {
              let formGroup = this.firstError(fg, controlKey, i);

              if (formGroup) {
                return formGroup;
              }
            }
          }
        } else {
          if (c.errors != null) {
            return (formArray ? formArray + "." : "") + controlKey + (node ? node : '');
          }
        }
      }
    }

    console.log('No errors found');
    return "";

  }

  getErrorCount(container: FormGroup): number {
    let errorCount = 0;
    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
          console.log(errorCount);
        }
      }
    }
    return errorCount;
  }
}
